import { 
    Button,
    Dialog, 
    DialogActions,
    DialogContent,
    FormControlLabel,
    Grid,
    Radio,
    RadioGroup,
    TextField,
 } from "@mui/material";

interface ProductFinishModalProps {
    isOpen: boolean;
    onClose: VoidFunction;
    formik: any; 
};

const ProductFinishModal = (props: ProductFinishModalProps & { isButtonDisabled: boolean }) => {
    const {isOpen, onClose, formik, isButtonDisabled} = props;

    return(
        <>
            <Dialog open = {isOpen} onClose={onClose} fullWidth>
                <DialogActions>
                    <Button onClick={onClose}>x</Button>
                </DialogActions>
                <form onSubmit = {formik.handleSubmit}>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin = "dense"
                        id = "finishName"
                        name = "finishName"
                        label  = {
                            formik.touched.finishName && formik.errors.finishName ? 
                            formik.errors.finishName : 
                            "Enter Finish Name"                                    
                        }
                        type = "text"
                        fullWidth
                        value = {formik.values.finishName}
                        onChange = {formik.handleChange}
                        error = {formik.touched.finishName && formik.errors.finishName}
                        onBlur = {formik.handleBlur}
                    />
                    <TextField
                        margin="dense"
                        id="leagoCode"
                        name="leagoCode"
                        label={
                            formik.touched.leagoCode && formik.errors.leagoCode
                            ? formik.errors.leagoCode
                            : "Enter LEAGO Code"
                        }
                        type="text"
                        fullWidth
                        value={formik.values.leagoCode ?? ""}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.leagoCode && formik.errors.leagoCode}
                    />
                    <Grid container spacing= {2}>
                        <Grid item xs = {8}>
                            <TextField
                                autoFocus
                                margin = "dense"
                                id = "jdeCode"
                                name = "jdeCode"
                                label  = {
                                    formik.touched.jdeCode && formik.errors.jdeCode ? 
                                    formik.errors.jdeCode : 
                                    "Enter JDE Code"                                    
                                }
                                type = "text"
                                fullWidth
                                value = {formik.values.jdeCode}
                                onChange = {formik.handleChange}
                                error = {formik.touched.jdeCode && formik.errors.jdeCode}
                                onBlur = {formik.handleBlur}
                            />
                        </Grid>
                        <Grid item xs = {4}>
                            <TextField
                                margin ="dense"
                                id = "pimKey"
                                name = "pimKey"
                                label  = {
                                    formik.touched.pimKey && formik.errors.pimKey ? 
                                    formik.errors.pimKey : 
                                    "Enter PIM Key"                                    
                                }
                                type = "text" 
                                value = {formik.values?.pimKey}
                                onChange={formik.handleChange}
                                error = {formik.touched.pimKey && formik.errors.pimKey}
                                onBlur = {formik.handleBlur}
                            />
                        </Grid>
                    </Grid>
                    <h4>Set Active</h4>
                    <RadioGroup
                        row
                        name = "isActive"
                        value = {formik.values.isActive}
                        onChange={(event) => formik.handleChange(event)}
                    >
                        <FormControlLabel value = {true} control = {<Radio/>} label = "Active"/>
                        <FormControlLabel value = {false} control = {<Radio/>} label = "Inactive" />
                    </RadioGroup>
                    <DialogActions>
                        <Button variant = "contained" type = "submit" disabled={isButtonDisabled}>
                            {formik.values.id>0 ? "Update Finish" : "Add Finish"}
                        </Button>
                    </DialogActions>
                </DialogContent>
                </form>
            </Dialog>
        </>
    )
};

export default ProductFinishModal;